import { render, staticRenderFns } from "./CustomerServiceTrackingNew.vue?vue&type=template&id=61c2606b&scoped=true&"
import script from "./CustomerServiceTrackingNew.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceTrackingNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceTrackingNew.vue?vue&type=style&index=0&id=61c2606b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c2606b",
  null
  
)

export default component.exports